export const UPDATE_USER = 'UPDATE_USER';
export const RESET_VALUE = 'RESET_VALUE';
export const UPDATE_ACCESS_KEY = 'UPDATE_ACCESS_KEY';
export const UPDATE_PROXY_SETTINGS = 'UPDATE_PROXY_SETTINGS';
export const UPDATE_PROXY_OBJECT = 'UPDATE_PROXY_OBJECT';
export const UPDATE_USER_REGION = 'UPDATE_USER_REGION';
export const UPDATE_VERBOSE = 'UPDATE_VERBOSE';

export function updateUser(payload: Object) {
  return {
    type: UPDATE_USER,
    payload,
  };
}

export function updateAccessKeyAndUsername(payload: Object) {
  return {
    type: UPDATE_ACCESS_KEY,
    payload,
  };
}

export function resetValues(payload: Object) {
  return {
    type: RESET_VALUE,
    payload,
  };
}

export function updateProxySettings(payload: Object) {
  return {
    type: UPDATE_PROXY_SETTINGS,
    payload,
  };
}

export function updateProxyObject(payload: Object) {
  return {
    type: UPDATE_PROXY_OBJECT,
    payload,
  };
}

export function updateVerbose(payload: Object) {
  return {
    type: UPDATE_VERBOSE,
    payload,
  };
}
